import { call, put, takeLatest } from "redux-saga/effects"
import { CustomerRepository, ListCustomer } from "../models/customer.model"
import {
  fetchCustomerRepositoryFailure,
  fetchCustomerRepositoryRequest,
  fetchCustomerRepositorySuccess,
  fetchCustomersFailure,
  fetchCustomersPayloadType,
  fetchCustomersRepositoryPayloadType,
  fetchCustomersRequest,
  fetchCustomersSuccess,
} from "../slices/customerSlice"
import {
  fetchCustomerRepositoryService,
  fetchCustomerService,
} from "../services/customerService"

function* listCustomersSaga(action: fetchCustomersPayloadType) {
  try {
    const { data } = yield call(fetchCustomerService, action)
    yield put(
      fetchCustomersSuccess({
        customers: data.data.map((contact: any) => new ListCustomer(contact)),
        totalRowCount: data.pagination.total,
      }),
    )
  } catch (error) {
    yield put(fetchCustomersFailure())
  }
}
function* listCustomerRepositorySaga(
  action: fetchCustomersRepositoryPayloadType,
) {
  try {
    const { data } = yield call(fetchCustomerRepositoryService, action)
    yield put(
      fetchCustomerRepositorySuccess({
        customers: data.data.map(
          (contact: any) => new CustomerRepository(contact),
        ),
        totalRowCount: data.pagination.total,
      }),
    )
  } catch (error) {
    yield put(fetchCustomerRepositoryFailure())
  }
}

export function* customerSaga() {
  yield takeLatest(fetchCustomersRequest, listCustomersSaga)
  yield takeLatest(fetchCustomerRepositoryRequest, listCustomerRepositorySaga)
}
